function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M25.3309 31.4737C25.3311 32.111 25.0864 32.7249 24.6458 33.1923C24.2052 33.6596 23.6013 33.9459 22.9552 33.9937L22.7625 34H20.1942C19.5462 34.0002 18.9221 33.7595 18.447 33.3261C17.9719 32.8927 17.6809 32.2987 17.6323 31.6632L17.6258 31.4737H25.3309ZM21.4784 10C23.8091 9.99996 26.0488 10.8904 27.7249 12.4835C29.401 14.0765 30.3825 16.2477 30.4624 18.5389L30.4676 18.8421V23.5966L32.8073 28.1996C32.9095 28.4004 32.9606 28.6226 32.9563 28.8471C32.952 29.0716 32.8924 29.2918 32.7827 29.4887C32.673 29.6857 32.5165 29.8535 32.3264 29.9779C32.1363 30.1023 31.9184 30.1795 31.6914 30.2029L31.5437 30.2105H11.413C11.1846 30.2106 10.9597 30.1562 10.7573 30.052C10.555 29.9478 10.3814 29.7969 10.2514 29.6122C10.1213 29.4276 10.0387 29.2147 10.0107 28.9917C9.98265 28.7688 10.01 28.5425 10.0903 28.3322L10.1494 28.1996L12.4891 23.5966V18.8421C12.4891 16.497 13.4362 14.248 15.122 12.5898C16.8078 10.9316 19.0943 10 21.4784 10Z",
  fill: "white"
});
function SvgBellIco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellIco);
export default __webpack_public_path__ + "static/media/bell_ico.dc26cae8627d7a1495aba395d218b40a.svg";
export { ForwardRef as ReactComponent };